import { render, staticRenderFns } from "./DiscussionsView.vue?vue&type=template&id=3bb5de25&"
import script from "./DiscussionsView.vue?vue&type=script&lang=js&"
export * from "./DiscussionsView.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports